import { useMutation } from "@apollo/client/react";
import { yupResolver } from "@hookform/resolvers/yup";
import FormError from "@repo/components/src/forms/formError";
import FormInputPassword from "@repo/components/src/forms/password";
import FormInputText from "@repo/components/src/forms/text";
import ModalProvider from "@repo/components/src/globalProviders/modal";
import LoadingButton from "@repo/components/src/shared/loadingButton";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import { VStack } from "@repo/components/src/ui/vstack";
import { logIn } from "@repo/graphql/client";
import { TokenAuthDocument } from "@repo/graphql/documents/user/mutation.generated";
import { useCallback } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import ForgotPasswordModal from "./forgotPasswordModal";
import { loginSchema } from "./schema";
import { LoginSchema } from "./types";

export default function Login() {
  const [logInMutation, { loading, error }] = useMutation(TokenAuthDocument, {
    onCompleted: (data, client) => {
      logIn(data.user.tokenAuth, client?.client);
    },
  });
  const formProps = useForm<LoginSchema>({
    resolver: yupResolver(loginSchema),
    mode: "onSubmit",
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const handleLogin: SubmitHandler<LoginSchema> = (data) => {
    logInMutation({
      variables: { email: data.email, password: data.password },
    });
  };
  const handleForgotPassword = useCallback(() => {
    ModalProvider.show({
      children: <ForgotPasswordModal />,
      size: "md",
      contentProps: { className: "rounded-2xl" },
    });
  }, []);
  return (
    <form onSubmit={formProps.handleSubmit(handleLogin)}>
      <VStack space="md">
        <FormInputText
          name="email"
          label="Email"
          control={formProps.control}
          placeholder="Email"
          required
          disabled={false}
          className={""}
          size={"md"}
          keyboardType="email-address"
          textContentType="emailAddress"
          autoCapitalize="none"
        />
        <FormInputPassword
          name="password"
          label="Contraseña"
          control={formProps.control}
          placeholder="Password"
          required
        />
        <FormError
          message={"Su correo o contraseña son incorrectos"}
          isInvalid={!!error}
        />
        <LoadingButton
          onPress={() => formProps.handleSubmit(handleLogin)()}
          loading={loading}
          loadingText="Iniciando sesión..."
        >
          Iniciar sesión
        </LoadingButton>
        <Button
          variant="link"
          action="muted"
          size="sm"
          onPress={handleForgotPassword}
        >
          <ButtonText>Olvidé mi contraseña</ButtonText>
        </Button>
        <button type="submit" hidden></button>
      </VStack>
    </form>
  );
}
